import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Header, Nav, HamburgerMenu, BtnSave } from './components'

import { loginUserCheck, logoutUser, userDelPoint } from '../redux/actions'

class AdminDelPoint extends Component {

    constructor() {
        super()
        this.state = {
            id: "",
            userid: "",
            name: "",
            point: 0,
            remark: "",
            toggleMenu: false
        }
    }

    componentWillMount() {
        this.props.loginUserCheck()
        const params = this.getParams(this.props.location)
        this.setState({
            id: params.id,
            userid: params.userid,
            name: params.name
        })
    }

    _handleMenu() {
        this.setState({ toggleMenu: !this.state.toggleMenu })
    }
    
    _handleLogout() {
        this.props.logoutUser()
    }

    getParams(location) {
        const searchParams = new URLSearchParams(location.search);
        return {
            id: searchParams.get('id') || '',
            userid: searchParams.get('userid') || '',
            name: searchParams.get('name') || ''
        };
    }

    _onHandleChange(event) {
		this.setState({
	    	[event.target.name]: event.target.value
	    });
    }

    _onSubmit() {
        let data = {
            userid: this.state.userid,
            invoice: "-",
            type: "deduct",
            point: Number(this.state.point),
            remark: this.state.remark,
            created_by: this.props.user
        }
        this.props.userDelPoint(this.state.id, data)
    }

    render() {
        return (
            <div>
                <Header name={this.props.user} logout={() => this._handleLogout()}/>
                <div className="admin-delpoint">
                    <Nav active="users"/>
                    <div className={(this.state.toggleMenu)? "content moveover": "content"}>
                        <div className="content-inner">
                            <HamburgerMenu onClick={()=>this._handleMenu()} />
                            <div className="title">
                                <h2>ลูกค้า : ลดคะแนน</h2>
                            </div>
                            <div className="info">
                                <div className="profile">
                                    <h3 className="user-id">{this.state.userid}</h3>
                                    <h3>&nbsp;:&nbsp;</h3>
                                    <h3 className="username">{this.state.name}</h3>
                                </div>
                                <div className="adjust">
                                    <div className="point">
                                        <form>
                                            <p>คะแนน</p>
                                            <input type="number" name="point" onChange={(event) => this._onHandleChange(event)}></input>
                                        </form>
                                    </div>
                                    <div className="remark">
                                        <form>
                                            <p>หมายเหตุ</p>
                                            <textarea name="remark" onChange={(event) => this._onHandleChange(event)}></textarea>
                                        </form>
                                    </div>
                                    <BtnSave click={() => this._onSubmit()}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
 
const mapStateToProps = ({ auth }) => {
    return { 
        user: auth.user
    }
}
 
export default connect(mapStateToProps, { 
    loginUserCheck, logoutUser, userDelPoint
})(AdminDelPoint);